import type { PropsWithChildren, ReactNode } from 'react'
import { Stack, styled, Tooltip, Typography } from '@mui/material'

type LabelValueRowProps = PropsWithChildren<{
  label: ReactNode
  valueTooltip?: ReactNode
  splitEvenly?: boolean
}>

export function LabelValueRow(props: LabelValueRowProps) {
  const { label, children, valueTooltip, splitEvenly } = props

  const maxWidth = splitEvenly ? 'calc(50% - 8px)' : undefined

  return (
    <Stack sx={{ flexDirection: 'row', alignItems: 'baseline', overflow: 'hidden', gap: 0.5 }}>
      <Typography noWrap sx={{ maxWidth }}>
        {label}
      </Typography>
      <Dots />
      <Tooltip title={valueTooltip} placement="top">
        <Typography noWrap sx={{ maxWidth }}>
          {children}
        </Typography>
      </Tooltip>
    </Stack>
  )
}

const Dots = styled('span', {
  name: 'Dots',
})(({ theme }) => ({
  position: 'relative',
  flex: 1,
  height: 1,
  minWidth: 0,

  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '1px',
    backgroundImage: `radial-gradient(circle, ${theme.vars.palette.text.primary} 0.5px, transparent 0.5px)`,
    backgroundSize: '3px 1px',
    backgroundRepeat: 'repeat-x',
    backgroundPosition: 'left center',
  },
}))
